module.exports = __webpack_public_path__ + "img/L_321_326.793786f6.png";